/**
 * Returns a string in a 'humanized' form i.e. text such as 'approvalRequired' will be return as 'Approval Required' 
 */
export const humanizeEnum = (input: string) => {
    if (!input) {
        return input;
    }
    
    //Add a space after any lower case characters and digits before the next capitalised word.
    input = input.replace(/([a-z0-9])([A-Z])/g, '$1 $2');

    let words = input.match(/[A-Za-z]+|\d+[A-Za-z]*|-|\+|\d+/g);

    let allWords = words.map(w => w.charAt(0).toUpperCase() + w.substring(1));
    let humanizedWords = "";
    for (let w in allWords) {
        humanizedWords = (allWords[w].length > 1) ? (humanizedWords + allWords[w] + " ") : (humanizedWords + allWords[w]);
    }

    return humanizedWords.trim();
}